<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.epicUrl"
        >
          Epic {{ notification.epicSequenceNumber }}
        </a>
      </BaseSubHeading>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator">{{
          notification.initiatorFullName
        }}</span>
        added a comment
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.comment"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :itemUrl="notification.epicUrl"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationComment } from "@/models/Notification/NotificationComment"

import { ReferencedText } from "../../Reference"

@Options({
  name: "EPIC_COMMENTS",
  components: {
    NotificationAttachmentFiles,
    NotificationTemplate,
    Avatar,
    ReferencedText
  }
})
export default class EPIC_COMMENTS extends Vue {
  @Prop() readonly notification: NotificationComment
}
</script>
